export interface TeamMembersColumn {
  key: string;
  label: string;
  // Percentage of the row's width, same convention as the leads table
  // (useLeadsTableHeader.tsx) - columns scale proportionally with the row
  // instead of a single column absorbing all leftover space.
  size: string;
  // Floor in px so columns don't get crushed on narrow screens, also matching
  // the leads table convention.
  minWidth?: string;
  align?: "left" | "center" | "right";
  // Only set for columns the backend can actually sort by
  // (AdminAccountControllerGetAllQueryParams["sort"]).
  sortable?: boolean;
}

// Keys for sortable columns match the backend's `sort` query param values
// directly, mirroring organizations-list-columns.ts.
export const TEAM_MEMBERS_COLUMNS: TeamMembersColumn[] = [
  { key: "lastName", label: "Name", size: "18%", minWidth: "160px", sortable: true },
  { key: "email", label: "Email Address", size: "24%", minWidth: "200px", sortable: true },
  { key: "isActive", label: "Access", size: "12%", minWidth: "100px", sortable: true },
  { key: "verified", label: "Verified", size: "12%", minWidth: "100px" },
  { key: "role", label: "Role", size: "12%", minWidth: "100px" },
  { key: "lastActive", label: "Last Active", size: "13%", minWidth: "120px" },
  { key: "actions", label: "", size: "9%", minWidth: "80px", align: "right" },
];
